import { isOrganization } from "@/share/validateOrganization";

export const MEMBER_ROLES = ["MEMBER", "MEMBERSHIP_USER"];

export const getEntityId = (value) => {
  if (!value) return null;

  if (typeof value === "object") {
    return value._id || value.id || null;
  }

  return value;
};

export const getHeadOfficeId = (user) => {
  if (!user) return null;

  return getEntityId(user.headOffice);
};

export const isAmpiMember = (user) => {
  if (!user || !MEMBER_ROLES.includes(user.role)) return false;

  return isOrganization(
    "ampi",
    user._id,
    getHeadOfficeId(user),
    user.organization
  );
};

/**
 * Resolves the branch used by member-affiliate flows.
 *
 * AMPI keeps its legacy profile-based branch selection. Other members always
 * use the branch assigned to the authenticated titular.
 */
export const resolveMemberAffiliateBranch = (
  user,
  userMembership,
  requestedBranch = null
) => {
  if (isAmpiMember(user)) {
    return (
      getEntityId(requestedBranch) ||
      getEntityId(userMembership && userMembership.organization) ||
      null
    );
  }

  const branchId = getEntityId(user && user.branchId);
  if (branchId) return branchId;

  return user && user.branch && typeof user.branch === "object"
    ? getEntityId(user.branch)
    : null;
};

